import React,{ Component } from "react";
import { connect } from "react-redux";
import { createImage } from "../../../actions/actionImage";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import ImageForm from "../ImageForm/ImageForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Images",path:"/images",isActive: false},
    {name: "CloneImages",path:"/cloneimage",isActive: true},
];

class CloneImage extends Component{
    render(){
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>      
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-clone"></i> <strong>Clone Image</strong>
                                </CardHeader>
                                <ImageForm
                                    createImage={this.props.createImage}
                                    imageId={this.props.match.params.id}
                                    fromUpdate={true}
                                    fromClone={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

CloneImage.propTypes = {
    createImage: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    images: state.images.images || []
}), 
dispatch => ({
    createImage: (data) => dispatch(createImage(data))
}))(CloneImage);


// WEBPACK FOOTER //
// ./src/views/Images/CloneImage/CloneImage.js